// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__JS8JV","Cancel":"schedule_Cancel__Yf2tO"};